import { ScanLine, Mail, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";
import { Reveal } from "@/components/motion-primitives";
import { SectionHead, usePageMeta } from "@/components/shared";

export default function Pay() {
  usePageMeta("Make a Payment", "Pay The Bermuda Co-Host securely by scanning our payment QR code — for services, cleans, ebooks and invoices.");
  return (
    <main>
      <section className="mx-auto max-w-[720px] px-6 pb-28 pt-40 text-center lg:px-10">
        <SectionHead
          align="center"
          overline="Payments"
          title={<>Pay <span className="italic text-bermuda-dark">The Bermuda Co-Host</span></>}
          copy="One code for everything — guest services, cleans, ebooks and invoices."
        />
        <Reveal delay={0.15}>
          <div className="mx-auto mt-12 max-w-sm border border-navy/10 bg-white p-8 shadow-xl shadow-navy/5" data-testid="pay-qr-card">
            <img src="/images/payment-qr.png" alt="The Bermuda Co-Host payment QR code" className="mx-auto w-full" data-testid="pay-qr-image" />
            <p className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-navy">
              <ScanLine size={16} className="text-bermuda-dark" /> Scan with your phone camera or payment app
            </p>
            <p className="mt-3 text-xs leading-relaxed text-navy/50">
              Please add your <strong className="text-navy/70">name and what the payment is for</strong> as the reference
              (e.g. "Smith — stayover refresh, 12 July" or "Jones — Blueprint ebook").
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-navy/55">
            Questions about a payment or invoice?{" "}
            <a href={`mailto:${BRAND.email}`} data-testid="pay-email-link" className="inline-flex items-center gap-1.5 text-bermuda-dark underline underline-offset-4 hover:text-navy"><Mail size={13} /> {BRAND.email}</a>
            {" · "}
            <a href={BRAND.phoneHref} data-testid="pay-phone-link" className="inline-flex items-center gap-1.5 text-bermuda-dark underline underline-offset-4 hover:text-navy"><Phone size={13} /> {BRAND.phone}</a>
          </p>
        </Reveal>
      </section>
    </main>
  );
}
